/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Fade from 'react-reveal/Fade';
import { useTranslation } from "react-i18next";

import {
  TitleOne,
  TextBodyOne,
  TitleThree,
  BorderText
} from '../../components/text'
import ic1 from '../../static/icons/vendor/auto/ic-1.svg'
import ic2 from '../../static/icons/vendor/auto/ic-2.svg'
import ic3 from '../../static/icons/vendor/auto/ic-3.svg'
import ic4 from '../../static/icons/vendor/auto/ic-4.svg'
import CardImage from '../../components/card-image'
import { Style } from './advantage.styles'

const Advantage = () => {
  const { t } = useTranslation();

  return (
    <Style>
      <Grid>
        <Row>
          <Col sm={12} xs={12} lg={5}>
            <Row>
              <Col sm={12} xs={12} lg={12} className="column-margin-bottom">
                <TitleOne display="block" align="left">
                  {t('pageSalonMobilPangilan.part40')}
                </TitleOne>
                <TextBodyOne display="block" align="left">
                  {t('pageSalonMobilPangilan.part41')}
                </TextBodyOne>
                <div className="border-text-wrap">
                  <Fade left>
                    <BorderText
                      background={'linear-gradient(279deg, #ff7dcf, #5069bb);'}
                    ></BorderText>
                  </Fade>
                </div>
                <TitleThree className="title-three">
                  {t('pageSalonMobilPangilan.part42')}
                </TitleThree>
                <TextBodyOne
                  className="text-body-one"
                  display="block"
                  align="left"
                >
                  {t('pageSalonMobilPangilan.part43')}
                </TextBodyOne>
              </Col>
            </Row>
          </Col>
          <Col sm={12} xs={12} lg={7}>
            <Row>
              <Col sm={12} xs={12} md={6} lg={6} className="bottom-margin">
                <CardImage
                  noShadow
                  noFluid
                  titleTop={false}
                  image={ic1}
                  imageFix
                  title={t('pageSalonMobilPangilan.part44')}
                  desc=""
                ></CardImage>
              </Col>
              <Col sm={12} xs={12} md={6} lg={6} className="bottom-margin">
                <CardImage
                  noShadow
                  noFluid
                  titleTop={false}
                  image={ic2}
                  imageFix
                  title={t('pageSalonMobilPangilan.part45')}
                  desc=""
                ></CardImage>
              </Col>
              <Col sm={12} xs={12} md={6} lg={6} className="bottom-margin">
                <CardImage
                  noShadow
                  noFluid
                  titleTop={false}
                  image={ic3}
                  imageFix
                  title={t('pageSalonMobilPangilan.part46')}
                  desc=""
                ></CardImage>
              </Col>
              <Col sm={12} xs={12} md={6} lg={6} className="bottom-margin">
                <CardImage
                  noShadow
                  noFluid
                  titleTop={false}
                  image={ic4}
                  imageFix
                  title={t('pageSalonMobilPangilan.part47')}
                  desc=""
                ></CardImage>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default Advantage
